import { FC } from "react";
import { ProviderMapResults } from "@app/projects/results/common/mapping";
import { ZipProviderCard } from "@app/projects/zip-projects/maps/components/ZipProviderCard";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";
import { ProviderBadgeStyle } from "@app/projects/enumerators";

export interface ZipNetworkProviderCardProps {
  provider: ProviderMapResults;
  isSelected: boolean;
  onClick: (provider: ProviderMapResults) => void;
}

/** Provider Listing Network Providers tab card */
export const ZipNetworkProviderCard: FC<ZipNetworkProviderCardProps> = ({ provider, isSelected, onClick }) => (
  <ZipProviderCard provider={provider} isSelected={isSelected} onClick={onClick}>
    <p><strong>Serves:</strong> {provider.servesPercent}%</p>
    <div className="me-2">
      <ProviderActionStatusBadge
        badgeStyle={ProviderBadgeStyle.Outline}
        status={provider.scenarioModelProviderStatus}
        hideWhenNullActionStatus={true}
      />
    </div>
  </ZipProviderCard>
);

export default ZipNetworkProviderCard;
